
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fCDBD", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.2bbc7aca.js.map
